import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { useActiveCustomer, useAuthentication } from '@haus-storefront-react/hooks'
import { useTranslation } from 'react-i18next'
import type { UserMenuAttributes } from './_propsFn'
import styles from './UserMenu.module.scss'

/**
 * User menu widget: when not logged in redirects to login;
 * when logged in opens a dropdown with a WordPress menu and logout action.
 */
const UserMenu = ({ menuItems = [] }: UserMenuAttributes) => {
  const { data: activeCustomer } = useActiveCustomer({ enabled: true })
  const isLoggedIn = activeCustomer != null
  const { logout } = useAuthentication({})
  const { t } = useTranslation()
  const triggerAriaLabel = t('a11y.account.accountDropdown.aria.ariaLabel')

  const handleRedirect = () => {
    window.location.href = t('urls.login')
  }

  const handleLogout = () => {
    logout()
    window.location.href = t('urls.login')
  }

  if (!isLoggedIn) {
    return (
      <div className={styles.root}>
        <button
          type="button"
          className={styles.trigger}
          aria-label={triggerAriaLabel}
          onClick={handleRedirect}
        />
      </div>
    )
  }

  return (
    <div className={styles.root}>
      <DropdownMenu.Root modal>
        <DropdownMenu.Trigger asChild>
          <button
            type="button"
            className={styles.trigger}
            aria-label={triggerAriaLabel}
            aria-haspopup="menu"
          >
            <div className={styles.loggedInStatus} />
          </button>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content sideOffset={6} align="end" className={styles.dropdownContent}>
          {menuItems.map((item, index) => (
            <DropdownMenu.Item key={`${item.url}-${index}`} asChild>
              <a href={item.url} className={styles.menuItemLink}>
                {item.title}
              </a>
            </DropdownMenu.Item>
          ))}
          {menuItems.length > 0 && <div className={styles.divider} role="separator" />}
          <DropdownMenu.Item onSelect={handleLogout} className={styles.logoutItem}>
            {t('account.accountDropdown.logout')}
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  )
}

export default UserMenu
